import { lazy } from 'react';

/** Загружает страницу формы шаблона уведомления */
export const NotificationTemplateFormPageAsync = lazy(
    () => import('./NotificationTemplateForm/NotificationTemplateFormPage'),
);
